import {
    FETCH_SAVED_ITEMS_REQUEST,
    FETCH_SAVED_ITEMS_SUCCESS,
    FETCH_SAVED_ITEMS_ERROR,
} from '../actionTypes/CartActionTypes';

const defaultState = {
    items: [],
    itemNumber: 0,
    isLoading: false,
    error: null,
};

const SavedItemsReducer = (state = defaultState, action = {}) => {
    switch (action.type) {
        case FETCH_SAVED_ITEMS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_SAVED_ITEMS_SUCCESS:
            return {
                ...state,
                items: (action.payload && action.payload.items) || [],
                itemNumber:
                    action.payload && typeof action.payload.itemNumber === 'number'
                        ? action.payload.itemNumber
                        : ((action.payload && action.payload.items) || []).length,
                isLoading: false,
                error: null,
            };
        case FETCH_SAVED_ITEMS_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.error || null,
            };
        default:
            return state;
    }
};

export default SavedItemsReducer;

